import Snackbar from './Snackbar';

const Plugin = function Plugin(Vue) {
  this.Vue = Vue;
  this.mounted = false;
  this.$root = {};
};

Plugin.prototype.mountIfNotMounted = function mountIfNotMounted() {
  if (this.mounted === true) {
    return;
  }

  this.$root = (() => {
    const SnackbarConstructor = this.Vue.extend(Snackbar);
    const node = document.createElement('div');
    document.querySelector('#app').appendChild(node);

    return new SnackbarConstructor().$mount(node);
  })();

  this.mounted = true;
};

Plugin.prototype.destroy = function destroy() {
  if (this.mounted === true) {
    const elem = this.$root.$el;
    this.$root.$destroy();
    this.$root.$off();
    elem.remove();
    this.mounted = false;
  }
};

Plugin.prototype.alert = function alert(message, timeout) {
  this.mountIfNotMounted();
  this.$root.open(message, true, timeout);
};

Plugin.prototype.info = function info(message, timeout) {
  this.mountIfNotMounted();
  this.$root.open(message, false, timeout);
};

Plugin.install = function install(vue, options) {
  const Vue = vue;
  Vue.snackbar = new Plugin(Vue, options);
  Vue.prototype.$snackbar = Vue.snackbar;
};

export default Plugin;
